<template>
    <div :style="'text-align:'+currentField.alignment+';'">
    <div v-if="showMore">
      <div class="heading" :style="'font-size:'+currentField.size+'px;'" v-html="currentField.paragraph"></div>
    </div>
    <div v-else>
        <div class="heading" :style="'font-size:'+currentField.size+'px;'" v-html="shortText"></div>
    </div>
      <a v-if="currentField.paragraph.length > maxCharacters"  href="" @click.prevent="toggleShowMore">{{ showMore ? "See less" : "See more" }}</a>
    </div>

</template>

<script>
export default {
  name: 'Paragraph',

  props: ['currentField'],
  data() {
    return {
      showMore: false,
      maxCharacters: 200,
      // input: ''
    };
  },
  computed:{
    shortText(){
      return this.currentField.paragraph.slice(0, this.maxCharacters);
    }
  },
  mounted() {

    this.$hub.$on('setParagraphContentLength', (data) => {
      this.maxCharacters = data.maxCharacters;
    });
  },
  methods: {
    toggleShowMore() {
      // Toggle the value of showMore to show or hide the full text
      this.showMore = !this.showMore;
    },
  },
};
</script>

<style>

/*.heading p {*/
/*  text-indent: 50px;*/
/*  text-align: justify;*/
/*  letter-spacing: 3px;*/
/*}*/

</style>
